jQuery('.review-customer').slick({
  centerMode: true,
  centerPadding: '560px',
  slidesToShow: 1,
  focusOnSelect: true,
  prevArrow:
    "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:
    "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
  responsive: [
    {
     breakpoint: 1500,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 1270,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: false,
        centerPadding: '40px',
        slidesToShow: 1,
      },
    },  
  ],
});
